import React from 'react';

export const LazySignInPage = React.lazy(() => import('./SignInPage'));
